<template>
    <div class="convention">
        <Form :model="formItem" :label-width="100">
            <FormItem :label="$t('convention.service_url1')">
                <Input v-model="formItem.kefu_url"></Input>
            </FormItem>
            <!-- <FormItem label="客服链接2">
                <Input v-model="formItem.input"></Input>
            </FormItem>-->
            <FormItem :label="$t('convention.siteTitle')">
                <Input v-model="formItem.web_title"></Input>
            </FormItem>
            <FormItem label="公告">
                <Input v-model="formItem.announcement" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
            </FormItem>
            <div class="rate_div">
                <div class="rate_item">
                    <span>{{$t('convention.currency_rate')}}</span>
                    <Input v-model="formItem.currency_rate"></Input>
                </div>
                <div class="rate_item">
                    <span>{{$t('convention.init_rate')}}</span>
                    <Input v-model="formItem.init_rate"></Input>
                </div>
            </div>
            <FormItem :label="$t('convention.model')">
                <RadioGroup v-model="formItem.mode">
                    <Radio :label="$t('convention.model1')">{{$t('convention.model1')}}</Radio>
                    <Radio :label="$t('convention.model2')">{{$t('convention.model2')}}</Radio>
                </RadioGroup>
            </FormItem>
<!--             <FormItem :label="$t('convention.middleVipPrice')">
                <Input v-model="formItem.vip1_price"></Input>
            </FormItem>
            <FormItem :label="$t('convention.advancedVipPrice')">
                <Input v-model="formItem.vip2_price"></Input>
            </FormItem> -->
            <!-- <FormItem label="关闭提示">
                <Input
                    v-model="formItem.textarea"
                    type="textarea"
                    :autosize="{minRows: 2,maxRows: 5}"
                ></Input>
            </FormItem>-->
            <FormItem :label="$t('convention.indexBanner')">
                <div class="file_bar">
                    <!-- 轮播图：仅展示已上传图片，添加=上传新图，删除=移除 -->
                    <div class="file_box" v-for="(item, index) in bannerList" :key="index">
                        <img class="id_img" :src="$ht_ip + item" alt />
                        <div
                            class="show_big_img"
                            @click="big_img = $ht_ip + item; show_big_img = true"
                        >{{$t('viewBigPotho')}}</div>
                        <Button type="error" size="small" icon="md-close" @click="removeRewardItem('banner', index)" style="position: absolute; top: 0; right: 0;"></Button>
                    </div>
                    <input
                        ref="bannerFileInput"
                        type="file"
                        accept="image/*"
                        style="display: none"
                        @change="onBannerFileChange"
                    />
                    <Button type="dashed" icon="md-add" @click="triggerBannerUpload" style="width: 100px;">{{$t('add')}}</Button>
                </div>
            </FormItem>
            <!-- 会员充值返佣          -->
            <FormItem :label="$t('convention.charge_rewards')">
                <div class="rewards-config">
                    <div 
                        v-for="(item, index) in chargeRewardsList" 
                        :key="index" 
                        class="rewards-item"
                    >
                        <Input 
                            v-model="item.min" 
                            :placeholder="$t('convention.minAmount')" 
                            type="number"
                            style="width: 120px; margin-right: 10px;"
                        />
                        <span style="margin: 0 5px;">-</span>
                        <Input 
                            v-model="item.max" 
                            :placeholder="$t('convention.maxAmount')" 
                            type="number"
                            style="width: 120px; margin-right: 10px;"
                        />
                        <span style="margin: 0 5px;">{{$t('convention.rewardAmount')}}:</span>
                        <Input 
                            v-model="item.amount" 
                            :placeholder="$t('convention.rewardAmount')" 
                            type="number"
                            style="width: 120px; margin-right: 10px;"
                        />
                        <Button 
                            type="error" 
                            size="small" 
                            icon="md-close"
                            @click="removeRewardItem('charge', index)"
                            style="margin-left: 10px;"
                        ></Button>
                    </div>
                    <Button 
                        type="dashed" 
                        icon="md-add" 
                        @click="addRewardItem('charge')"
                        style="width: 100%; margin-top: 10px;"
                    >{{$t('add')}}</Button>
                </div>
            </FormItem>
            <!-- 邀请返佣 -->
            <FormItem :label="$t('convention.invite_rewards')">
                <div class="rewards-config">
                    <div 
                        v-for="(item, index) in inviteRewardsList" 
                        :key="index" 
                        class="rewards-item"
                    >
                        <Input 
                            v-model="item.min" 
                            :placeholder="$t('convention.minAmount')" 
                            type="number"
                            style="width: 120px; margin-right: 10px;"
                        />
                        <span style="margin: 0 5px;">-</span>
                        <Input 
                            v-model="item.max" 
                            :placeholder="$t('convention.maxAmount')" 
                            type="number"
                            style="width: 120px; margin-right: 10px;"
                        />
                        <span style="margin: 0 5px;">{{$t('convention.rewardAmount')}}:</span>
                        <Input 
                            v-model="item.amount" 
                            :placeholder="$t('convention.rewardAmount')" 
                            type="number"
                            style="width: 120px; margin-right: 10px;"
                        />
                        <Button 
                            type="error" 
                            size="small" 
                            icon="md-close"
                            @click="removeRewardItem('invite', index)"
                            style="margin-left: 10px;"
                        ></Button>
                    </div>
                    <Button 
                        type="dashed" 
                        icon="md-add" 
                        @click="addRewardItem('invite')"
                        style="width: 100%; margin-top: 10px;"
                    >{{$t('add')}}</Button>
                </div>
            </FormItem>
            <!-- 层级返佣 -->
            <FormItem :label="$t('convention.level_rewards')">
                <div class="rewards-config">
                    <div 
                        v-for="(item, index) in levelRewardsList" 
                        :key="index" 
                        class="rewards-item"
                    >
                        <Input 
                            v-model="item.level" 
                            :placeholder="$t('level')" 
                            type="number"
                            style="width: 120px; margin-right: 10px;"
                        />
                        <span style="margin: 0 5px;">-</span>
                        <span style="margin: 0 5px;">{{$t('convention.rewardAmount')}}:</span>
                        <Input 
                            v-model="item.amount" 
                            :placeholder="$t('convention.rewardAmount')" 
                            type="number"
                            style="width: 120px; margin-right: 10px;"
                        />
                        <Button 
                            type="error" 
                            size="small" 
                            icon="md-close"
                            @click="removeRewardItem('level', index)"
                            style="margin-left: 10px;"
                        ></Button>
                    </div>
                    <Button 
                        type="dashed" 
                        icon="md-add" 
                        @click="addRewardItem('level')"
                        style="width: 100%; margin-top: 10px;"
                    >{{$t('add')}}</Button>
                </div>
            </FormItem>
            <!-- 充值地址 -->
            <FormItem :label="$t('convention.charge_address')">
                <div class="rewards-config">
                    <div v-for="(item, index) in chargeAddressList" :key="index" class="rewards-item">
                        <Input 
                            v-model="item.network" 
                            :placeholder="$t('convention.network')" 
                            style="width: 150px; margin-right: 10px;"
                        />
                        <Input 
                            v-model="item.address" 
                            :placeholder="$t('convention.address')" 
                            style="width: 300px; margin-right: 10px;"
                        />
                        <Button 
                            type="error" 
                            size="small" 
                            icon="md-close" 
                            @click="removeRewardItem('charge_address', index)"
                            style="margin-left: 10px;"
                        ></Button>
                    </div>
                    <Button 
                        type="dashed" 
                        icon="md-add" 
                        @click="addRewardItem('charge_address')"
                        style="width: 100%; margin-top: 10px;"
                    >{{$t('add')}}</Button>
                </div>
            </FormItem>
            <FormItem :label="$t('convention.vip_limit')">
                <Input v-model="formItem.vip_limit" :placeholder="$t('convention.vip_limit')" />
            </FormItem>
            <FormItem>
                <Button type="primary" @click="doPost">{{$t('submit')}}</Button>
                <Button style="margin-left: 8px">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>
        <Modal v-model="show_big_img" :title="$t('viewBigPhoto')" width="600" @on-ok="big_img = ''">
            <img class="big_img" :src="big_img" alt />
        </Modal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            formItem: {},
            banner: "",
            img_load: false,
            big_img: "",
            // current_rate: 0,
            // init_rate: 0,
            show_big_img: false,
            chargeRewardsList: [],
            inviteRewardsList: [],
            levelRewardsList: [],
            chargeAddressList: [],
            bannerList: [],
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        doPost() {
            // 将返佣配置转换为 JSON 格式
            // 确保数组存在且是数组类型
            const chargeRewards = Array.isArray(this.chargeRewardsList) ? this.chargeRewardsList : [];
            const inviteRewards = Array.isArray(this.inviteRewardsList) ? this.inviteRewardsList : [];
            const levelRewards = Array.isArray(this.levelRewardsList) ? this.levelRewardsList : [];
            const chargeAddress = Array.isArray(this.chargeAddressList) ? this.chargeAddressList : [];
            const bannerList = Array.isArray(this.bannerList) ? this.bannerList : [];
            // 转换为 JSON 字符串格式，因为后端需要存储 JSON 数据
            this.formItem.charge_rewards = JSON.stringify(chargeRewards);
            this.formItem.invite_rewards = JSON.stringify(inviteRewards);
            this.formItem.level_rewards = JSON.stringify(levelRewards);
            this.formItem.charge_address = JSON.stringify(chargeAddress);
            this.formItem.banner_list = JSON.stringify(bannerList);
            this.$post(this.$path.system, this.formItem).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            }).catch(err => {
                console.error('提交失败:', err);
                this.$Message.error(this.$i18n.t('operateFailed'));
            });
        },
        loadData() {
            this.$get(this.$path.system, {}).then(res => {
                if (res.data) {
                    this.formItem = res.data;
                    if (this.formItem.banner_selection !== undefined && this.formItem.banner_selection !== null) {
                        this.formItem.banner_selection = String(this.formItem.banner_selection);
                    }
                    
                    // 解析 JSON 数据
                    if (res.data.charge_rewards) {
                        try {
                            if (typeof res.data.charge_rewards === 'string') {
                                this.chargeRewardsList = JSON.parse(res.data.charge_rewards);
                            } else if (Array.isArray(res.data.charge_rewards)) {
                                this.chargeRewardsList = res.data.charge_rewards;
                            } else {
                                this.chargeRewardsList = [];
                            }
                        } catch (e) {
                            console.error('解析 charge_rewards 失败:', e);
                            this.chargeRewardsList = [];
                        }
                    } else {
                        this.chargeRewardsList = [];
                    }
                    
                    if (res.data.invite_rewards) {
                        try {
                            if (typeof res.data.invite_rewards === 'string') {
                                this.inviteRewardsList = JSON.parse(res.data.invite_rewards);
                            } else if (Array.isArray(res.data.invite_rewards)) {
                                this.inviteRewardsList = res.data.invite_rewards;
                            } else {
                                this.inviteRewardsList = [];
                            }
                        } catch (e) {
                            console.error('解析 invite_rewards 失败:', e);
                            this.inviteRewardsList = [];
                        }
                    } else {
                        this.inviteRewardsList = [];
                    }
                    
                    if (res.data.level_rewards) {
                        try {
                            if (typeof res.data.level_rewards === 'string') {
                                this.levelRewardsList = JSON.parse(res.data.level_rewards);
                            } else if (Array.isArray(res.data.level_rewards)) {
                                this.levelRewardsList = res.data.level_rewards;
                            } else {
                                this.levelRewardsList = [];
                            }
                        } catch (e) {
                            console.error('解析 level_rewards 失败:', e);
                            this.levelRewardsList = [];
                        }
                    } else {
                        this.levelRewardsList = [];
                    }
                    if (res.data.charge_address) {
                        try {
                            if (typeof res.data.charge_address === 'string') {
                                const parsed = JSON.parse(res.data.charge_address);
                                this.chargeAddressList = Array.isArray(parsed) ? parsed : [];
                            } else if (Array.isArray(res.data.charge_address)) {
                                this.chargeAddressList = res.data.charge_address;
                            } else {
                                this.chargeAddressList = [];
                            }
                        } catch (e) {
                            console.error('解析 charge_address 失败:', e);
                            this.chargeAddressList = [];
                        }
                    } else {
                        this.chargeAddressList = [];
                    }
                    if (res.data.banner_list) {
                        this.bannerList = res.data.banner_list;
                        // console.log(this.bannerList);
                    } else {
                        this.bannerList = [];
                    }
                } else {
                    this.$Message.error(this.$i18n.t('dataFailed'));
                }
            });
        },
        get_file(e, index) {
            this.img_load = true;
            let formData = new FormData();
            formData.append("img", e.currentTarget.files[0]);
            this.$file(this.$path.upload, formData)
                .then(res => {
                    this.img_load = false;
                    if (index == 1) {
                        this.formItem.banner1 = res.data.path;
                    } else if(index==2) {
                        this.formItem.banner2 = res.data.path;
                    }else{
                        this.formItem.seal = res.data.path
                    }
                })
                .catch(err => {
                    this.img_load = false;
                });
        },
        triggerBannerUpload() {
            this.$refs.bannerFileInput && this.$refs.bannerFileInput.click();
        },
        onBannerFileChange(e) {
            const file = e.target.files && e.target.files[0];
            if (!file) return;
            this.img_load = true;
            const formData = new FormData();
            formData.append("img", file);
            this.$file(this.$path.upload, formData)
                .then(res => {
                    this.img_load = false;
                    if (res.data && res.data.path) {
                        this.bannerList.push(res.data.path);
                    }
                    e.target.value = '';
                })
                .catch(err => {
                    this.img_load = false;
                    e.target.value = '';
                });
        },
        addRewardItem(type) {
            const newItem = { min: '', max: '', amount: '' };
            const newAddressItem = { network: '', address: '' };
            const levelItem = {level: '', amount: ''};
            if (type === 'charge') {
                this.chargeRewardsList.push(newItem);
            } else if (type === 'invite') {
                this.inviteRewardsList.push(newItem);
            } else if (type === 'level') {
                this.levelRewardsList.push(levelItem);
            } else if (type === 'charge_address') {
                this.chargeAddressList.push(newAddressItem);
            } else if (type === 'banner') {
                this.triggerBannerUpload();
            }
        },
        removeRewardItem(type, index) {
            if (type === 'charge') {
                this.chargeRewardsList.splice(index, 1);
            } else if (type === 'invite') {
                this.inviteRewardsList.splice(index, 1);
            } else if (type === 'level') {
                this.levelRewardsList.splice(index, 1);
            } else if (type === 'charge_address') {
                this.chargeAddressList.splice(index, 1);
            } else if (type === 'banner') {
                this.bannerList.splice(index, 1);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.top,
.bottom {
    text-align: center;
}
.file_bar {
    display: flex;
    flex-direction: row;
    .file_box {
        display: flex;
        flex-direction: column;
        width: 200px;
        height: 170px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border: 1px #eeeeee dashed;
        border-radius: 4px;
        margin-right: 20px;
        .show_big_img {
            width: 100%;
            height: 20px;
            cursor: pointer;
            text-align: center;
        }
        img {
            width: 100%;
            height: 150px;
        }
        .img {
            width: 100%;
            height: 100%;

            p {
                text-align: center;
                color: #bab9b9;
                margin-top: 50px;
            }
        }
        input {
            position: absolute;
            top: 0;
            left: 0;
            width: 200px;
            height: 150px;
            opacity: 0;
        }
    }
}
.rewards-config {
    width: 100%;
    .rewards-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        padding: 10px;
        background: #f8f8f9;
        border-radius: 4px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/system/convention.vue